const noop = /* @__NO_SIDE_EFFECTS__ */ (any) => any;
export {
  noop
};
